/**
 *
 * @param {String} text text for escape
 * @return {String} escaped text
 */
export default function escapeHTML(text) {
   return text.toString().split('&').join('&amp;').split('<').join('&lt;').split('"').join('&quot;');
}
